import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24491 24616"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528318400320">
        <path
          d="M22570 24616h-1454c-128 0-230-103-230-230V3214H3611v21172c0 127-103 230-231 230H1926c-128 0-230-103-230-230V2984c0-128 102-231 230-231h20647c128 0 230 103 230 231v21402c-2 127-108 230-233 230zm-1227-461h994V3214h-994v20941zm-19189 0h993V3214h-993v20941z"
          className="fil0"
        />
        <path
          d="M24263 3214H230c-128 0-230-103-230-230C0 1338 1338 0 2984 0h18523c1646 0 2984 1338 2984 2984 3 127-100 230-228 230zM472 2753h23550c-117-1282-1199-2292-2515-2292H2984C1671 461 588 1471 472 2753z"
          className="fil0"
        />
        <path
          d="M10250 22909c-450 0-850-189-1086-477-238 288-635 477-1085 477s-849-189-1085-477c-239 288-635 477-1085 477-725 0-1316-491-1316-1099V2984c0-128 103-231 231-231h6511c128 0 231 103 231 231v18826c0 608-592 1099-1316 1099zm-1085-1327c127 0 230 103 230 231 0 352 383 638 855 638s855-286 855-638V3217H5054v18596c0 352 383 638 855 638s855-286 855-638c0-128 102-231 230-231s230 103 230 231c0 352 383 638 855 638s855-286 855-638c-3-128 103-231 231-231z"
          className="fil0"
        />
        <path
          d="M6994 22040c-128 0-230-102-230-230v-5568c0-128 102-230 230-230s230 102 230 230v5568c0 128-105 230-230 230zM9165 22040c-128 0-231-102-231-230V11538c0-128 103-231 231-231 127 0 230 103 230 231v10272c0 128-106 230-230 230zM18585 22909c-450 0-850-189-1086-477-238 288-635 477-1085 477-449 0-846-189-1085-477-236 288-636 477-1085 477-725 0-1316-491-1316-1099V2984c0-128 103-231 230-231h6512c127 0 230 103 230 231v18826c0 608-588 1099-1315 1099zm-855-1096c0 352 383 638 855 638 471 0 854-286 854-638V3217h-6050v18596c0 352 383 638 855 638s855-286 855-638c0-128 102-231 230-231s230 103 230 231c0 352 383 638 855 638s855-286 855-638c0-128 103-231 230-231 128 0 231 103 231 231z"
          className="fil0"
        />
        <path
          d="M17499 22040c-127 0-230-102-230-230v-5568c0-128 103-230 230-230 128 0 231 102 231 230v5568c0 128-103 230-231 230zM15329 22040c-128 0-230-102-230-230V11538c0-128 102-231 230-231s230 103 230 231v10272c0 128-102 230-230 230z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
